import {
    CREATE_PIM_FAILURE,
    CREATE_PIM_REQUEST,
    CREATE_PIM_SUCCESS,
    CREATE_USER_FORM_PIM,
    FETCH_SINGLE_PIM_FAILURE,
    FETCH_SINGLE_PIM_REQUEST,
    FETCH_SINGLE_PIM_SUCCESS,
    FETCH_PIM_FAILURE,
    FETCH_PIM_REQUEST,
    FETCH_PIM_SUCCESS,
    NAVIGATE_PIM_DETAILS,
    NAVIGATE_PIM,
    PIM_USERFORM_RESET,
    UPDATE_PIM_FAILURE,
    UPDATE_PIM_REQUEST,
    UPDATE_PIM_SUCCESS,
    DELETE_PIM_REQUEST,
    DELETE_PIM_SUCCESS,
    DELETE_PIM_FAILURE,
    NAVIGATE_ADDITIONAL_EXPENSE,
    FETCH_PIM_SUPPLIER_REQUEST,
    FETCH_PIM_SUPPLIER_SUCCESS,
    FETCH_PIM_SUPPLIER_FAILURE,
    FETCH_PENDING_PIM_REQUEST,
    FETCH_PENDING_PIM_SUCCESS,
    FETCH_PENDING_PIM_FAILURE,
    FETCH_PO_DC_PIM_REQUEST,
    FETCH_PO_DC_PIM_SUCCESS,
    FETCH_PO_DC_PIM_FAILURE,
    CREATE_MULTIPLE_PIM_REQUEST,
    CREATE_MULTIPLE_PIM_FAILURE,
    CREATE_MULTIPLE_PIM_SUCCESS,
    FETCH_PIM_PROGRAM_REQUEST,
    FETCH_PIM_PROGRAM_SUCCESS,
    FETCH_PIM_PROGRAM_FAILURE,
    SET_ACTIVE_KEY_PIM_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_INWARD_ID_DK,
    FETCH__PIM_BILLS_PROGRAM_REQUEST,
    FETCH__PIM_BILLS_PROGRAM_SUCCESS,
    FETCH__PIM_BILLS_PROGRAM_FAILURE
} from './pim.actionsType';

export const PIM = 'pim';

let initialState = {
    loading: false,
    pimMaster: [],
    pimSupplier: [],
    pimProgram: [],
    pimPoDcMaster: [],
    activeKey: 1,
    // yarnInwardId: 0,
    pendingPimMaster: [],
    userform: { fldAID: 'A' },
    selectedTeam: {},
    navigation: 'pimMaster',
    selectedPIMMasterData: {},
    errorMessage: '',
    iperrorMessage: '',
    pimBills: []
};

export let PimReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_PIM_REQUEST:
        case FETCH_PO_DC_PIM_REQUEST:
        case FETCH_PENDING_PIM_REQUEST:
        case FETCH_PIM_SUPPLIER_REQUEST:
        case FETCH_PIM_PROGRAM_REQUEST:
        case CREATE_PIM_REQUEST:
        case CREATE_MULTIPLE_PIM_REQUEST:
        case FETCH_SINGLE_PIM_REQUEST:
        case UPDATE_PIM_REQUEST:
        case DELETE_PIM_REQUEST:
        case FETCH__PIM_BILLS_PROGRAM_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PIM_SUCCESS:
            return {
                ...state,
                loading: false,
                pimMaster: updatePayload
            };
        case FETCH_PO_DC_PIM_SUCCESS:
            return {
                ...state,
                loading: false,
                pimPoDcMaster: updatePayload
            };
        case FETCH_PENDING_PIM_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingPimMaster: updatePayload
            };
        case FETCH_PIM_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                pimSupplier: updatePayload
            };
        case FETCH_PIM_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                pimProgram: updatePayload
            };
        case FETCH__PIM_BILLS_PROGRAM_SUCCESS: {
            return {
                ...state,
                loading: false,
                pimBills: updatePayload
            };
        }
        case CREATE_PIM_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldAID: 'A' },
                yarnInwardId: updatePayload,
                activeKey: updatePayload[0]?.fldId && payload == true ? 2 : 1
            };
        case CREATE_MULTIPLE_PIM_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldAID: 'A' }
            };
        case FETCH_SINGLE_PIM_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                userform: updatePayload
            };
        case SET_ACTIVE_KEY_PIM_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case UPDATE_PIM_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: {},
                userform: { fldAID: 'A' }
            };
        case DELETE_PIM_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldAID: 'A' },
                selectedTeam: {}
            };
        case FETCH_PIM_FAILURE:
        case FETCH_PO_DC_PIM_FAILURE:
        case FETCH_PENDING_PIM_FAILURE:
        case FETCH_PIM_SUPPLIER_FAILURE:
        case FETCH_PIM_PROGRAM_FAILURE:
        case FETCH_SINGLE_PIM_FAILURE:
        case CREATE_PIM_FAILURE:
        case CREATE_MULTIPLE_PIM_FAILURE:
        case UPDATE_PIM_FAILURE:
        case DELETE_PIM_FAILURE:
        case FETCH__PIM_BILLS_PROGRAM_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };

        case CREATE_USER_FORM_PIM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case PIM_USERFORM_RESET:
            return {
                ...state,
                userform: { fldAID: 'A' },
                selectedTeam: {},
                // yarnInwardId: [],
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_INWARD_ID_DK:
            return {
                ...state,
                userform: { fldAID: 'A' },
                selectedTeam: {}
            };
        case NAVIGATE_PIM_DETAILS:
            return {
                ...state,
                navigation: 'pimDetails',
                selectedPIMMasterData: updatePayload?.selectedPIMMasterData
            };
        case NAVIGATE_PIM:
            return {
                ...state,
                navigation: 'pimMaster'
            };
        case NAVIGATE_ADDITIONAL_EXPENSE:
            return {
                ...state,
                navigation: 'pimAdditionalExpense',
                selectedPIMMasterData: updatePayload
            };
        default:
            return state;
    }
};
